import { type Logger, TaggedLogger } from '@core/logging/logger'
import { PushSDK } from './push-sdk'
import { inSourcelessIFrame } from './utils/in-sourceless-iframe.ts'

/**
 * Re-exported for typings/library entry
 */
export { PushSDK }

type AsyncLoadedPushSdk = PushSDK | Array<any>

let logger: Console | Logger
try {
    logger = TaggedLogger._getInstance()
} catch {
    logger = console
}

try {
    if (!(window.self === window.top || inSourcelessIFrame())) {
        logger.warn('PushlySDK must be loaded from the top frame or a sourceless iFrame')
    } else {
        const existingSdk = window.PushlySDK as AsyncLoadedPushSdk
        if (existingSdk && existingSdk instanceof Array) {
            for (const command of existingSdk) {
                PushSDK.push(command)
            }
        }

        window.PushlySDK = PushSDK
    }
} catch (err) {
    logger.warn('Unable to assign global PushlySDK')
    logger.error(err)
}
